import axios from 'axios';
const dataFetching = axios.create({
    baseURL: 'https://kgf.cic.kz/api',
});
export default dataFetching;